<template>
    <div class="step-number step-number--instruction d-flex mb-2">
        <i class="align-self-center">{{count}}</i>
        <div class="step-number-container align-self-center">
            <div class="step-number-container--title text-accent-1"><strong>{{title}}</strong></div>

            <div v-if="instruction" class="small step-number-container--content">{{instruction}}</div>
        </div>
    </div>
</template>

<script>
	// add imports here

	//ADD JSDOC HERE!!!!!
	export default {
		props: ['content'],
		mounted() {
//			console.log('this.content', this.content);
			if (typeof this.content !== 'undefined') {
				this.count = this.content.count || null;
				this.title = this.content.title || null;
				this.instruction = this.content.instruction || null;
			}
		},
		data() {
			return {
				count: null,
				title: null,
				instruction: null
			}
		},
		methods: {}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/steps/step-simple-instructions.vue?5759336f